<template>
  <div class="container">
    <div class="head_handle">
      <el-button type="primary" @click="dialogVisible = true; flag = 0">新建模板</el-button>
      <div>
        <el-input style="width:fit-content" placeholder="请输入关键字进行查询" v-model="params.key"></el-input>
        <el-button @click="handleQuery" type="primary">查询</el-button>
        <el-button @click="params.key = ''; getTemplatePageList()" type="warning">重置</el-button>
      </div>
    </div>

    <el-table :data="templatePageList" style="width: 100%; margin-top: 20px" border>
      <el-table-column prop="Name" label="模板名称" align="center" />
      <el-table-column prop="CreateTime" label="创建时间" align="center" />
      <el-table-column label="操作" align="center">
        <template #default="{ row }">
          <div style="display: flex; width: 100%; gap: 20px; justify-content: center;">
            <el-button type="primary" size="mini" @click="handleEdit(row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDelTemplate(row)" style="margin: 0;">删除</el-button>

            <el-upload class="upload-demo" action="#" multiple :show-file-list="false" :file-list="tableFile"
              :auto-upload="false" accept=".xls,.xlsx" :limit="1" :on-change="handleFileChange2">
              <el-button size="mini" type="warning" @click="handleZntq(row)">智能提取</el-button>
            </el-upload>

          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page"
      :page-sizes="[5, 10, 15, 20]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="total"
      background style="margin-top: 10px" />

    <el-dialog :title="flag ? '编辑模板' : '新建模板'" :visible.sync="dialogVisible" top="20px" width="100%" @close="handleClose">
      <div class="dispose">
        <div class="upload">
          <el-upload class="upload-demo" action="#" multiple :file-list="file" :auto-upload="false"
            :on-change="handleFileChange" :on-remove="handleRemove" accept=".xls,.xlsx" :limit="1"
            :on-exceed="handleExceed" v-if="flag === 0">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
          </el-upload>
          <div style="display: flex; align-items: center">
            <span style="width: 120px; font-size: 16px">模板名称：</span>
            <el-input placeholder="请输入模板名称" v-model="templateName"></el-input>
          </div>
        </div>
        <div class="body">
          <div class="window">
            <div class="filter">
              <el-input placeholder="请输入关键字进行查询" v-model="searchVal"></el-input>
            </div>
            <div class="window_list">
              <template v-if="searchExcelHeader.length !== 0">
                <div v-for="(i, idx) in searchExcelHeader" :key="idx" class="window_item"
                  :class="{ active: activeIdx === idx }" @click="handleClick_item($event, i, idx)">
                  <span>{{ idx + 1 }}. {{ i }}</span>
                </div>
              </template>
              <div v-else class="hint">
                <span>请上传文件后查看</span>
              </div>
            </div>
          </div>
          <div class="show_box">
            <el-input type="textarea" rows="27" resize="none" v-model="textareaVal" readonly></el-input>
          </div>
          <div class="field">
            <el-button :disabled="templateObj[activeField]?.length > 0 || activeField == ''" v-if="!flag"
              @click="handleBegin">开始</el-button>
            <div class="field_item" v-for="(formVal, idx) in templateObj[activeField]" :key="idx">
              <el-form ref="formVal" :model="formVal" label-width="auto" :inline="true">
                <div class="display:flex;align-items: center;">
                  <span style="font-size: 16px; color: #666666">唯一标识 &nbsp;</span>
                  <el-checkbox v-model="formVal.IsPrimarykey" style="margin-right: 20px"></el-checkbox>
                </div>
                <el-form-item label="字段类型">
                  <el-select v-model="formVal.DataType" size="small">
                    <el-option value="0" label="数值"></el-option>
                    <el-option value="1" label="文本"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="字段名">
                  <el-input v-model="formVal.Name" size="small"></el-input>
                </el-form-item>
                <el-form-item label="开始">
                  <el-input v-model="formVal.StartChar" size="small"></el-input>
                </el-form-item>
                <el-form-item label="结束">
                  <el-input v-model="formVal.EndChar" size="small"></el-input>
                </el-form-item>
              </el-form>
              <div>
                <el-button icon="el-icon-plus" size="mini" circle type="primary" @click="handleAdd(idx)"></el-button>
                <el-button icon="el-icon-minus" size="mini" circle type="danger" @click="handleMiuns(formVal, idx)"
                  v-if="idx !== 0"></el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </template>
    </el-dialog>
    <el-dialog title="智能提取" :visible.sync="dialogVisible2" @close="handleClose">
      <el-upload class="upload-demo" action="#" multiple :file-list="file" :auto-upload="false"
        :on-change="handleFileChange" :on-remove="handleRemove" accept=".xls,.xlsx" :limit="1" :on-exceed="handleExceed"
        v-if="flag === 0">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <template #footer>
        <el-button @click="this.dialogVisible2 = false">取消</el-button>
        <el-button @click="handleconfirm" type="primary">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from "xlsx";
import templateApi from "../../api/template";
export default {
  data() {
    return {
      file: [],
      excelData: [],
      searchexcenlHeader: [],
      dialogVisible: false,
      editVisible: false,
      dialogVisible2: false,
      textVareaal: "",
      activeIdx: -1,
      activeField: "",
      templateName: "",
      templateList: [],
      templateObj: {},
      searchVal: "",
      params: {
        page: 1,
        rows: 10,
        key: "",
      },
      templatePageList: [],
      textareaVal: "",
      total: 0,
      TemplateId: "",
      flag: 0, // 0新增 1编辑
      row: {},
      tableFile: [],
      flagNum: 0,
      textVareaalArr: {}
    };
  },
  methods: {
    async getTemplatePageList() {
      let res = await templateApi.templatePageList(this.params);
      this.templatePageList = res.data.Data.rows;
      this.total = res.data.Data.total;
    },
    handleFileChange(file, fileList) {
      this.file = fileList;
    },
    handleFileChange2(file, fileList) {
      this.tableFile = fileList;
    },
    handlesuccess(...args) {
      // console.log(this.row);
      // console.log(args);
      return
      let params = {
        TemplateId: row.Id,
        DataSource: row.DataSource,
        Source: []
      }
      if (!params.TemplateId) return
      console.log(params);
      return
      this.excelData.forEach(i => params.Source.push(i[this.row.DataSource]))
      templateApi.zntq(params).then((res) => this.$message.success('智能提取成功'))
    },
    handleRemove(file, fileList) {
      this.file = fileList;
    },
    handleExceed() {
      this.$message.warning("只能上传一个文件");
    },
    readExcel(file) {
      //表格导入
      let vali = /\.(xls|xlsx)$/;
      if (!vali.test(file.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        this.file = [];
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        try {
          const data = e.target.result; // data则是我们在excel表中获取的数据
          const Workbook = XLSX.read(data, { type: "binary" }); // 通过XLSX读取出来得到了一个 workdata 对象，下面详细介绍 workdata 对象中有些什么
          this.excelData = XLSX.utils.sheet_to_json(
            Workbook.Sheets[Workbook.SheetNames[0]]
          );
          // console.log(Workbook);
        } catch (e) {
          return false;
        }
      };
      fileReader.readAsBinaryString(file);
    },
    handleClick_item(e, item, idx) {
      this.activeField = item;
      this.activeIdx = idx;
      this.textareaVal = this.excelData[0][item];
    },
    handleAdd(idx) {
      this.templateObj[this.activeField].splice(idx + 1, 0, {
        IsPrimarykey: false,
        StartChar: "",
        EndChar: "",
        DataSource: this.activeField,
        Name: "",
        Sort: idx + 1,
        DataType: "",
      });
    },
    async handleMiuns(row, idx) {
      if (this.flag === 0) {
        this.templateObj[this.activeField].splice(idx, 1);
        this.templateObj[this.activeField].forEach((i, idx) => i.Sort = idx)
      } else {
        let res = await templateApi.delRule(row.RuleId);
        this.templateList.splice(idx, 1);
      }
    },
    handleBegin() {
      this.$set(this.templateObj, this.activeField, [{
        IsPrimarykey: false,
        StartChar: "",
        EndChar: "",
        DataSource: this.activeField,
        Name: "",
        Sort: 0,
        ParsingText: this.textareaVal,
      }]);
    },
    async handleSave() {
      if (this.flagNum < 1) return this.$message.error('请设置唯一标识')
      Object.values(this.templateObj).forEach(i => {
        i.forEach(j => {
          if (j.ParsingText) this.textVareaalArr[j.DataSource] = j.ParsingText
        })
        this.templateList.push(...i)
      })
      let params = {
        RuleList: this.templateList,
        TemplateName: this.templateName,
        ParsingText: JSON.stringify(this.textVareaalArr),
        TemplateId: this.TemplateId
      };
      if (this.flag) {
        params.ParsingText = JSON.stringify(this.excelData[0])
      }
      let res = await templateApi.setTemplate(params);
      this.getTemplatePageList()
      this.dialogVisible = false;
    },
    handleDelTemplate(row) {
      this.$confirm("此操作将永久删除该字段, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await templateApi.delTemplate(row.Id);
          this.getTemplatePageList()
          this.$message.success("删除成功")
        })
        .catch(() => { });
    },
    handleSizeChange(limit) {
      this.params.rows = limit;
      this.getTemplatePageList();
    },
    handleCurrentChange(page) {
      this.params.page = page;
      this.getTemplatePageList();
    },
    handleQuery() {
      this.getTemplatePageList();
    },
    handleClose() {
      this.templateList = [];
      this.file = [];
      this.excelData = [];
      this.searchexcenlHeader = [];
      this.activeIdx = -1;
      this.templateName = "";
      this.searchVal = "";
      this.TemplateId = "";
      this.textareaVal = "";
      this.templateObj = {}
      this.activeField = ""
      this.textVareaalArr = {}
    },
    async handleEdit(row) {
      this.flag = 1
      this.templateName = row.Name;
      this.TemplateId = row.Id;
      let res = await templateApi.getTemplate(row.Id);
      this.excelData.push(JSON.parse(res.data.ParsingText))

      let obj = {}
      res.data.RuleList.forEach(i => {
        if (Array.isArray(obj[i.DataSource])) {
          obj[i.DataSource].push(i)
        } else {
          obj[i.DataSource] = []
          obj[i.DataSource].push(i)
        }
      })
      this.templateObj = obj
      this.dialogVisible = true;
    },
    handleZntq(row) {
      this.row = row;
      // console.log(this.row);
    },
    async handleconfirm() {
      if (this.file.length === 0) {
        this.$message.error('请上传文件')
        return false
      }
      let params = {
        TemplateId: this.row.Id,
        DataSource: this.row.DataSource,
        Source: []
      }
      this.excelData.forEach(i => params.Source.push(i[this.row.DataSource]))
      // console.log(params);
      let res = await templateApi.zntq(params)
      this.$message.success('智能提取成功')
      this.dialogVisible2 = false;
    }
  },
  created() {
    this.getTemplatePageList();
  },
  watch: {
    file(val) {
      if (val.length === 0) {
        this.excelData = [];
      } else {
        this.readExcel(val[0].raw);
      }
    },
    tableFile(val) {
      if (val.length === 0) {
        this.excelData = [];
      } else {
        this.readExcel(val[0].raw);
        setTimeout(() => {
          let params = new FormData()
          params.append('TemplateId', this.row.Id)
          params.append('Excel', val[0].raw)
          templateApi.zntq(params).then((res) => {
            this.$message.success('智能提取成功')
            this.tableFile = []
          })
        }, 100);
      }
    },
    templateObj: {
      handler(val) {
        this.flagNum = 0
        Object.values(val).forEach(i => {
          i.forEach(j => {
            if (j.IsPrimarykey) {
              this.flagNum++
              if (this.flagNum > 1) {
                this.$message.error('唯一标识只能有一个')
                j.IsPrimarykey = false
              }
            }
          })
        })


      },
      deep: true
    }
  },
  computed: {
    excelHeader: {
      get() {
        return this.excelData.length === 0
          ? []
          : Object.keys(this.excelData[0]);
      },
      set(val) {
        this.searchexcenlHeader = val;
      },
    },
    searchExcelHeader() {
      return this.excelHeader.filter((i) => i.includes(this.searchVal));
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-form-item__content) {
  width: 150px !important;
}

.container {
  :deep(.el-dialog__header) {
    span {
      color: #fff !important;
    }
  }

  :deep(.el-dialog__footer) {
    text-align: center;
  }

  .head_handle {
    display: flex;
    gap: 30px;

    &>div {
      &>* {
        margin-right: 10px;
        margin-left: 0px;
      }
    }
  }
}

.dispose {
  .upload {
    width: fit-content;
    display: flex;
    gap: 20px;
  }

  .body {
    display: grid;
    grid-template-columns: 0.2fr 0.2fr 1fr;
    gap: 1vw;
    margin-top: 20px;

    .field {
      width: 100%;
      height: 60vh;
      border: 1px solid #d9dbe2;
      border-radius: 5px;
      padding: 10px;
      box-sizing: border-box;
      overflow: auto;

      .field_item {
        display: flex;
        align-items: center;
        gap: 20px;

        .el-form {
          display: flex;
          align-items: center;

          &>div {
            margin: 0;
            display: flex;
          }
        }
      }
    }

    .window {
      box-sizing: border-box;
      height: 60vh;
      overflow: hidden;

      .window_list {
        width: 100%;
        height: calc(60vh - 50px);
        box-sizing: border-box;
        overflow: auto;

        .window_item {
          box-sizing: border-box;
          width: 100%;
          height: 40px;
          border: 1px solid #d9dbe2;
          border-radius: 5px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: 0.1s;
          overflow: hidden;

          &:hover {
            background-color: #f5f7fa;
          }

          span {
            width: 100%;
            height: 100%;
            text-align: left;
            padding-left: 6px;
          }
        }

        .active {
          background-color: rgba(64, 158, 255, 0.9) !important;
          color: #fff !important;
        }

        .hint {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #666;
          user-select: none;
        }
      }

      .filter {
        margin-bottom: 10px;
        // position: sticky;
        // top: 0;
      }
    }
  }

  .hide {
    grid-template-columns: 0fr 0.2fr 1fr;
  }

  .bottom_btn {
    text-align: right;
    margin-right: 20px;
    margin-top: 30px;
  }
}
</style>